import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../../slice'
import createPublishRosterSlice, { PublishRosterSlice } from './publish/slice'
import createRosterTemplatesSlice, {
  RosterTemplatesSlice,
} from './templates/slice'
import createCopyRosterSlice, { CopyRosterSlice } from './copy/slice'
import createRostersSlice, { RostersSlice } from './slice'

const useRosterStore = create<
  RostersSlice &
    PublishRosterSlice &
    RosterTemplatesSlice &
    CopyRosterSlice &
    SharedSlice
>()((...props) => ({
  ...createSharedSlice(...props),
  ...createPublishRosterSlice(...props),
  ...createRostersSlice(...props),
  ...createRosterTemplatesSlice(...props),
  ...createCopyRosterSlice(...props),
}))

export default useRosterStore
